import React from 'react';
import './hero.css';
import bt from '../assets/bt.jpg';

const Banner = () => {
  return (
    <section className="bookstor-bann">
      <img src={bt} alt="banner" className="bg-image" />
      <div className="bann-overlay">
        <div className="bann-left">
          <div className="bann-text-box">
            <h1 className="bann-heading">Sangit Shree Prakashan</h1>
            <p className="bann-subtext">
              Our platform is dedicated to providing authentic and comprehensive
              books on theory, practical, and history of Hindustani Classical music.
            </p>
          </div>
        </div>
        <div className="bann-right"></div> {/* Optional: can be removed */}
      </div>
    </section>
  );
};

export default Banner;
